import { Service, inject } from '@angular/core'
import {
  CancelEventParticipationBody,
  CreateEventParticipationBody,
  DeleteEntityResponse,
  EditEventParticipationBody,
  EventParticipation,
  GetEventParticipationsQuery,
  GetManagedEventParticipationsResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class ManageEventParticipationApiService {
  private readonly api = inject(ApiService)

  getManagedEventParticipations(entityId: string, query: GetEventParticipationsQuery, init?: RequestInit) {
    const url = this.api.createURL(`manage/entities/${entityId}/event-participations`)
    url.search = this.api.toQueryParams(query)
    return this.api.protectedFetchJson<GetManagedEventParticipationsResponse>(url, { ...init })
  }

  createEventParticipation(entityId: string, body: CreateEventParticipationBody, init?: RequestInit) {
    return this.api.protectedFetchJson<EventParticipation>(`manage/entities/${entityId}/event-participations`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  editEventParticipation(
    entityId: string,
    eventParticipationId: string,
    body: EditEventParticipationBody,
    init?: RequestInit,
  ) {
    return this.api.protectedFetchJson<EventParticipation>(
      `manage/entities/${entityId}/event-participations/${eventParticipationId}`,
      {
        method: 'PATCH',
        body: JSON.stringify(body),
        ...init,
      },
    )
  }

  /**
   * Cancels a sign-up: it stays, marked cancelled, and its place goes to the waiting list. Refused with
   * `eventParticipation.eventStarted` once the event started.
   */
  cancelEventParticipation(
    entityId: string,
    eventParticipationId: string,
    body: CancelEventParticipationBody,
    init?: RequestInit,
  ) {
    return this.api.protectedFetchJson<EventParticipation>(
      `manage/entities/${entityId}/event-participations/${eventParticipationId}/cancel`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        ...init,
      },
    )
  }

  /** Removes a participation made by mistake. Refused with `eventParticipation.eventEnded` once the event has ended. */
  deleteEventParticipation(entityId: string, eventParticipationId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<DeleteEntityResponse>(
      `manage/entities/${entityId}/event-participations/${eventParticipationId}`,
      {
        method: 'DELETE',
        ...init,
      },
    )
  }
}
